export default {
  lastForPeriod({ period }) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/crms/documents-delivery/last-for-period/${ period }`);
  },
  setForSettlement(data) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/subscription-settlements/documents-delivery-date`, data);
  },
};
